<template>
  <img
    v-tooltip="tooltip"
    data-testid="external-icon"
    :src="$imagesRequire('account_mapping/icon-external.svg')"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const tooltip = computed(() => {
  return window.I18n.t('account_mapping_list.tooltip.external_tooltip')
})
</script>
